import { isSameDay } from 'date-fns'

import { PlannerItemResponse, PlannerItemType, ScheduledPlannerItem } from '@/types/Planner'

import { parseDate } from '.'

export const getPlannerItemColor = (recordType: PlannerItemType): string => {
  switch (recordType) {
    case 'reservation':
      // green-200
      return '#209987'
    case 'task manager':
      // grey-700
      return '#1B1918'
    case 'task':
      // grey-700
      return '#1B1918'
    case 'job':
      // blue-200
      return '#0469DA'
    default:
      // grey-700
      return '#1B1918'
  }
}

export const isItemUnscheduled = (item: PlannerItemResponse) =>
  item.scheduleType === 'flexible' && item?.startTime === null

export const getUnscheduledDataForDay = (
  data: PlannerItemResponse[] | undefined,
  selectedDate: Date,
): PlannerItemResponse[] => {
  if (!data) return []
  const plannerItemsForDay = getPlannerItemsForDay(data, selectedDate)
  return plannerItemsForDay.filter((item) => !item?.isScheduled)
}

export const getPlannerItemTitle = (item: PlannerItemResponse) => {
  if (item?.reservation?.member?.fullName && item?.home?.searchDocument) {
    return `${item?.reservation?.member?.fullName} - ${item?.home?.searchDocument}`
  } else if (item?.home?.searchDocument) {
    return `${item?.home?.searchDocument}`
  } else {
    return item?.recordType
  }
}

export const getPlannerItemsForDay = (data: PlannerItemResponse[], selectedDate: Date): PlannerItemResponse[] => {
  return data.filter((item) => {
    if (item.dueDate) {
      const dueDate = parseDate(item.dueDate, 'yyyy-MM-dd')
      return dueDate ? isSameDay(selectedDate, dueDate) : false
    } else {
      return false
    }
  })
}

export const getPlannerDataForCalendar = (data: PlannerItemResponse[] | undefined): ScheduledPlannerItem[] => {
  if (!data) return []
  // map planner data to AppointmentModel for react-scheduler (https://devexpress.github.io/devextreme-reactive/react/scheduler/docs/reference/scheduler/#appointmentmodel)
  return data
    .filter((item) => item.startTime !== null)
    .map((item) => {
      const startDatetime = `${item?.startTime}`
      const endDatetime = item?.endTime ? `${item?.endTime}` : undefined
      return {
        startDate: startDatetime,
        endDate: endDatetime,
        title: getPlannerItemTitle(item),
        ...item,
      }
    })
}
